import { toast } from '@quinyx/ui';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  getModules,
  editModuleApi,
  getNEOModules,
  editNEOModuleApi,
} from '../../api/endpoints/module';
import { IModule } from '../../api/interfaces/customer';
import i18n from '@/i18n';

const notifySuccess = (message: string) =>
  toast({
    message: i18n.t(message),
    type: 'positive',
  });

const notifyError = () =>
  toast({
    message: i18n.t('toast.somethingWentWrong'),
    type: 'negative',
  });

export const useGetModules = (domainId?: string) =>
  useQuery({
    queryKey: [`modules_${domainId}`],
    queryFn: () => getModules(domainId),
  });

export const useGetNEOModules = (domainId?: string) =>
  useQuery({
    queryKey: [`neo_modules_${domainId}`],
    queryFn: () => getNEOModules(domainId),
  });

export const useEditModule = () => {
  const queryClient = useQueryClient();
  const { mutate: updateModule, ...rest } = useMutation<
    IModule,
    Error,
    { domainId: string; payload: IModule }
  >({
    mutationFn: editModuleApi,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [`modules_${variables.domainId}`],
      });
      notifySuccess('toast.moduleUpdated');
    },
    onError: () => {
      notifyError();
    },
  });
  return { updateModule, ...rest };
};

export const useEditNEOModule = () => {
  const queryClient = useQueryClient();
  const { mutate: updateNEOModule, ...rest } = useMutation<
    IModule,
    Error,
    { domainId: string; payload: IModule }
  >({
    mutationFn: editNEOModuleApi,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [`neo_modules_${variables.domainId}`],
      });
      notifySuccess('toast.moduleUpdated');
    },
    onError: () => {
      notifyError();
    },
  });
  return { updateNEOModule, ...rest };
};
